import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=bf94d10c&scoped=true&"
import script from "./archive.vue?vue&type=script&lang=js&"
export * from "./archive.vue?vue&type=script&lang=js&"
import style0 from "./archive.vue?vue&type=style&index=0&id=bf94d10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94d10c",
  null
  
)

export default component.exports